import { html, type TemplateResult } from 'lit';
import {
  type PwaInstallGuidanceKind,
  pwaInstallGuidanceSteps,
  pwaInstallGuidanceTitle,
} from '@src/modules/shell-ui/infrastructure/shellPwaInstallUi.ts';

export function shellPwaInstallGuideTemplate(
  kind: PwaInstallGuidanceKind,
  opts?: { dismissible?: boolean; onDismiss?: () => void },
): TemplateResult {
  const steps = pwaInstallGuidanceSteps(kind);
  return html`
    <div
      class="shell-pwa-install-guide flex flex-col gap-2 rounded-md border border-[color:var(--md-sys-color-primary)]/25 bg-[color:var(--md-sys-color-primary-container)] px-4 py-3 text-sm text-[color:var(--md-sys-color-on-primary-container)]"
      role="status"
    >
      <div class="flex items-start justify-between gap-3">
        <p class="m-0 font-medium">${pwaInstallGuidanceTitle(kind)}</p>
        ${opts?.dismissible
          ? html`
              <button
                type="button"
                class="md-btn-icon shrink-0 text-[color:var(--md-sys-color-on-primary-container)]"
                aria-label="Ocultar aviso de instalación"
                @click=${opts.onDismiss}
              >
                <svg class="md-btn-icon__glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            `
          : null}
      </div>
      <ol class="m-0 list-decimal space-y-1 pl-5">
        ${steps.map((step) => html`<li>${step}</li>`)}
      </ol>
    </div>
  `;
}

export function shellIosWeeklyReminderTemplate(onDismiss?: () => void): TemplateResult {
  return html`
    <div
      class="shell-ios-weekly-reminder flex items-start justify-between gap-3 rounded-md border border-[color:var(--md-sys-color-tertiary)]/30 bg-[color:var(--md-sys-color-tertiary-container)] px-4 py-3 text-sm text-[color:var(--md-sys-color-on-tertiary-container)]"
      role="status"
    >
      <p class="m-0">
        Hace más de una semana sin abrir la app. Ábrala con conexión al menos una vez por semana para conservar sus
        datos locales en iPhone o iPad.
      </p>
      ${onDismiss
        ? html`
            <button
              type="button"
              class="md-btn-icon shrink-0 text-[color:var(--md-sys-color-on-tertiary-container)]"
              aria-label="Ocultar recordatorio"
              @click=${onDismiss}
            >
              <svg class="md-btn-icon__glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          `
        : null}
    </div>
  `;
}
